import { render, staticRenderFns } from "./LongTextInput.vue?vue&type=template&id=df561642&scoped=true"
import script from "./LongTextInput.vue?vue&type=script&lang=js"
export * from "./LongTextInput.vue?vue&type=script&lang=js"
import style0 from "./LongTextInput.vue?vue&type=style&index=0&id=df561642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df561642",
  null
  
)

export default component.exports